import React from 'react';
import { AppContext } from '../AppContext';

const MainMenu = (props) => {
    const app = React.useContext(AppContext);
    let tapCount = 0;


    const version = app.version;

    const showMoreGames = app.marketPlace.hasGames();

    const tapTitle = React.useCallback(() => {
        app.userdata.titleTapped = (app.userdata.titleTapped || 0) + 1;
        app.achievements.checkForAchievementAndReward(app.userdata);
        app.save();
    });
    const tapVersion = React.useCallback(() => {
        tapCount += 1;
        if (tapCount > 10) {
            app.navigate("Test");
        }
    });
    return (
        <div id="MainMenu1" className="page1 activePage">
            <div className="wrapper">
                <div className="pageTitle" style={{padding: "25px 0 5px 0"}}>
                    <img src="assets/Title.png" onClick={tapTitle} />
                </div>
                <ul className="buttonList" >
                    <li>
                        <a className="button buttonEasy" href="#ComputerMenu">
                            Play
                        </a>
                    </li>
                    <li>
                        <a className="button buttonHard" href="#Achievements">
                            Achievements
                        </a>
                    </li>
                    {/* <li>
                        <div id="player1GamerTag" className="gamerTag">
                            <a href="#/Settings">
                                <img className="gamerTagImage" id="player1Img" data-src="avatar"
                                    src="assets/Avatars/default-avatar.png" />
                                <div className="coins" data-inner-text="coins">0</div>
                                <div id="player1Name" className='title' data-inner-text="name">Player</div>

                                <div className='description'>
                                    <img className="miniIcon" src="assets/Buttons/other/Star.png" />
                                    Level <span data-inner-text="level">0</span>
                                </div>
                                <div className="description">
                                    <img className="miniIcon" src="assets/Buttons/other/Throphy.png" />
                                    <progress id="progressAchievements" className="progress" data-max="achievementMax"
                                        data-value="achievementCount"></progress>
                                </div>

                            </a>
                        </div>
                    </li> */}



                    <li>
                        <div className="minibuttons" >
                            <a href="#HowToPlay"><img src="assets/Buttons/white/questionmark.png" /></a>

                            <a href="#Achievements"><img src="assets/Buttons/white/achievement.png" /></a>
                            <a href="#Statistics"><img src="assets/Buttons/white/stats.png" /></a>
                            <a href="#About"><img src="assets/Buttons/white/mail.png" /></a>
                            {/* <a data-show="showRateGame" > <img src="assets/Buttons/white/heart.png" /> </a> */}
                            {/* <a href="#Settings"><img src="assets/Buttons/white/settings.png" /></a> */}

                        </div>
                    </li>
                    {showMoreGames && (
                        <li style={{ textAlign: 'center' }}>
                            <div >
                                <a className="buttonMoreGames" href="#MoreGames">
                                </a>
                                <div>More Games</div>
                            </div>
                        </li>
                    )}
                    {!showMoreGames && (
                        <li style={{ textAlign: 'center', margin: '8px 8px' }}>
                            JD Games
                        </li>
                    )}

                    <li style={{ textAlign: 'center', margin: '10px 10px' }}>
                        <div onClick={tapVersion}  >
                            {version}
                        </div>
                    </li>
                </ul>

            </div>

        </div>
    )
};

export default MainMenu;

